import registerActions from './registerActions';
import registerMenuItems from './registerMenuItems';

let helpers = {
	registerActions,
	registerMenuItems
};

type HelperKeys = keyof typeof helpers;

// generate a dynamic mapped type based on the functions in the collection of helpers
// see https://www.typescriptlang.org/docs/handbook/advanced-types.html#mapped-types
export type Helpers = {
	[P in HelperKeys]:() => void;
}

export default angular
	.module('sharebase-app.helpers', [])
	.factory('helpers', [
		'$injector',
		($injector: ng.auto.IInjectorService) => {
			return Object.keys(helpers)
				.reduce((all, k) => {
					all[k] = () => $injector.invoke(helpers[k]);
					return all;
				}, {} as Helpers);
		}
	]);



// WEBPACK FOOTER //
// ./src/sharebase-app/components/_app/helpers/index.ts